module.exports = __webpack_public_path__ + "static/media/product_secure.7f77d9c9.svg";